/* eslint-disable react-hooks/exhaustive-deps */
import {useAddUser, useRemoveUser, useSetUserNames} from 'api/modules/obsView';
import Button from 'components/Form/Button/Button';
import React, {useCallback, useRef} from 'react';
import {ObsEvent} from 'types/entities/Obs';

type ObsViewParams = {
  link: string;
  title?: string;
};

const IFRAME_ID = 'ObsAdminPanel';

const ObsView: React.FC<ObsViewParams> = ({link, title}) => {
  const iframeElement = useRef<HTMLIFrameElement>(null);

  const addUser = useAddUser();
  const removeUser = useRemoveUser();
  const setUserNames = useSetUserNames();

  const getUsersAndLabels = useCallback(() => {
    iframeElement.current?.contentWindow?.postMessage(
      {
        getStreamIDs: true,
      },
      '*',
    );
  }, [iframeElement]);

  const onMessageRecieved = (event: MessageEvent<any>) => {
    if (
      event.data &&
      iframeElement &&
      iframeElement.current &&
      event.source !== iframeElement.current.contentWindow
    )
      return;

    if (event.data.streamIDs) {
      setUserNames.mutate(event.data.streamIDs);
      return;
    }

    const eventData = event.data as ObsEvent;
    switch (eventData.action) {
      case 'new-track-added':
        if (eventData.streamID) {
          addUser.mutate({streamID: eventData.streamID});
          getUsersAndLabels();
        }
        break;

      case 'end-view-connection':
        if (eventData.value) removeUser.mutate(eventData.value);
        break;

      default:
        break;
    }
  };

  React.useEffect(() => {
    window.removeEventListener('message', onMessageRecieved);
    window.addEventListener('message', onMessageRecieved);

    iframeElement.current?.contentWindow?.postMessage(
      {
        getStreamIDs: true,
      },
      '*',
    );
  }, [iframeElement]);

  return (
    <>
      <iframe
        className="w-full h-96"
        title={title ?? 'ObsAdmin'}
        id={IFRAME_ID}
        src={link}
        ref={iframeElement}
        allow="camera; microphone"
      />
      <Button onClick={() => getUsersAndLabels()} className="w-full mt-3">
        Refresh names
      </Button>
    </>
  );
};

export default ObsView;
